export default __webpack_public_path__ + "static/media/logo.059e4788.png";